import React, { useState } from 'react';

interface ColorPickerProps {
  color: string;
  onChange: (color: string) => void;
}

const PRESET_COLORS = [
  '#000000', '#ffffff', '#ff0000', '#00ff00', '#0000ff',
  '#ffff00', '#ff00ff', '#00ffff', '#ffa500', '#800080',
  '#008000', '#800000', '#000080', '#808080', '#c0c0c0',
];

export const ColorPicker: React.FC<ColorPickerProps> = ({ color, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      {/* Color preview button */}
      <button
        className="w-8 h-8 rounded border-2 border-gray-300 hover:border-gray-400 transition-colors"
        style={{ backgroundColor: color }}
        onClick={() => setIsOpen(!isOpen)}
        title="Choose color"
      />

      {/* Color picker dropdown */}
      {isOpen && (
        <div className="absolute top-full left-0 mt-2 p-3 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
          <div className="space-y-3">
            {/* Preset colors */}
            <div className="grid grid-cols-5 gap-2">
              {PRESET_COLORS.map((presetColor) => (
                <button
                  key={presetColor}
                  className="w-6 h-6 rounded border-2 hover:border-gray-400 transition-colors"
                  style={{ 
                    backgroundColor: presetColor,
                    borderColor: color === presetColor ? '#3b82f6' : '#d1d5db'
                  }}
                  onClick={() => {
                    onChange(presetColor);
                    setIsOpen(false);
                  }}
                />
              ))}
            </div>

            {/* Custom color input */}
            <div className="space-y-2">
              <label className="text-xs font-medium text-gray-600">Custom Color</label>
              <input
                type="color"
                value={color}
                onChange={(e) => onChange(e.target.value)}
                className="w-full h-8 rounded border border-gray-300 cursor-pointer"
              />
            </div>

            {/* Hex input */}
            <div className="space-y-2">
              <label className="text-xs font-medium text-gray-600">Hex Code</label>
              <input
                type="text"
                value={color}
                onChange={(e) => onChange(e.target.value)}
                className="w-full px-2 py-1 text-xs border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="#000000"
              />
            </div>
          </div>
        </div>
      )}

      {/* Click outside to close */}
      {isOpen && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};
